import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from '@/components/ui/dialog';
import { X, ArrowUpRight } from 'lucide-react';

const OV_INFO_URL = 'https://www.psimammoliti.com/servicios/orientacion-vocacional';

interface OVConditionsModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const OVConditionsModal: React.FC<OVConditionsModalProps> = ({ open, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="sm:max-w-md w-full p-0 overflow-hidden">
        <div className="px-6 pt-6 pb-4 relative" style={{ background: 'linear-gradient(180deg, #f5f3ff 0%, #ffffff 100%)' }}>
          <DialogClose className="absolute top-4 right-4 rounded-full w-7 h-7 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
            <X size={16} />
          </DialogClose>
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold pr-8" style={{ color: '#1e1b4b' }}>
              Antes de continuar, leé con atención las condiciones del servicio de Orientación Vocacional.
            </DialogTitle>
          </DialogHeader>
        </div>

        <div className="px-6 py-4 flex flex-col gap-4">
          <p className="text-sm text-gray-700 leading-relaxed m-0">
            El proceso de Orientación Vocacional tiene una duración de 8 sesiones completas. Los honorarios se liquidan únicamente al finalizar el proceso completo — no se abona por sesiones individuales ni por procesos que no lleguen a completarse, independientemente del motivo.
          </p>
          <p className="text-sm text-gray-700 leading-relaxed m-0">
            Si en algún momento no podés continuar con un proceso en curso, es fundamental que nos lo comuniques a la brevedad y colabores activamente en la derivación: compartiendo tus notas clínicas y facilitando toda la información que el nuevo profesional necesite para darle continuidad al proceso de la manera más ordenada posible.
          </p>
          <p className="text-xs text-gray-500 m-0">
            Podés conocer en detalle en qué consiste el proceso{' '}
            <a
              href={OV_INFO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-purple-500 hover:text-purple-700 transition-colors font-medium"
            >
              acá <ArrowUpRight size={12} />
            </a>
          </p>
        </div>

        <div className="px-6 py-4 border-t border-gray-100 flex flex-col gap-2">
          <button
            type="button"
            className="btn-purple w-full"
            onClick={onConfirm}
          >
            Confirmar y continuar
          </button>
          <button
            type="button"
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors py-1"
            onClick={onCancel}
          >
            Cancelar
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OVConditionsModal;
